import { ComponentPropsWithRef, FC, forwardRef, HTMLAttributes, MutableRefObject, PropsWithChildren, Ref } from 'react';
import styled, { css } from 'styled-components';
import { MaybeStyledCSS } from '@belong/types';

interface IControlledHeightContainer
  extends PropsWithChildren,
    ComponentPropsWithRef<any>,
    HTMLAttributes<HTMLElement> {
  height?: string;
}

const Container = styled.div<{ height?: string }>`
  width: 100%;
  ${({ height }): MaybeStyledCSS =>
    height
      ? css`
          height: ${height};
          > * {
            // Ensure children absorb all height if set
            height: 100%;
          }
        `
      : ''}
`;

// Refs are used to track heights of callouts + alerts across all the plan cards
export const updateHeightTrackerRefs = (
  ref: Ref<HTMLElement>,
  columnIndex: number,
  elementRefs?: MutableRefObject<Ref<HTMLElement>[]>
): void => {
  if (elementRefs?.current && ref) {
    const newRefs = [...elementRefs.current];
    newRefs[columnIndex] = ref;
    // eslint-disable-next-line no-param-reassign
    elementRefs.current = newRefs;
  }
};

// Helper to simplify creating ref handlers
export const createRefHandler =
  (columnIndex: number, elementRefs?: MutableRefObject<Ref<HTMLElement>[]>) =>
  (ref: Ref<HTMLElement>): void => {
    updateHeightTrackerRefs(ref, columnIndex, elementRefs);
  };

export const ControlledHeightContainer: FC<IControlledHeightContainer> = forwardRef<any, IControlledHeightContainer>(
  ({ children, height, ...containerProps }, ref) => {
    return (
      <Container height={height} ref={ref} {...containerProps}>
        {children}
      </Container>
    );
  }
);

ControlledHeightContainer.displayName = 'ControlledHeightContainer';
